import React from "react";
import { observer, inject } from "mobx-react";

import { Heading } from "grommet";

import BookElement from "app/api/bookElement";

import SectionBreak from "app/components/BookElements/SectionBreak";
import TableOfContentsEntry from "app/components/BookElements/TableOfContentsEntry";
import Paragraph from "app/components/Paragraph";
import Anchor from "app/components/Anchor";

class Information extends React.Component {
  render() {
    const { path } = this.props;
    if (BookElement.isNotSelected(path)) return null;

    return (
      <React.Fragment>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Information
          </Heading>
        </TableOfContentsEntry>
        <Paragraph>
          The printed versions of Modern War in an Ancient Land Volume I and
          Volume II is available from the U.S. Army Center of Military History
          (CMH).
        </Paragraph>
        <Paragraph>
          The CMH Publications Catalog is available at: (
          <Anchor href="https://history.army.mil/catalog/index.html">
            https://history.army.mil/catalog/index.html
          </Anchor>
          )
        </Paragraph>

        <Paragraph>
          The PDF versions of Volume I and Volume II are available at:(
          <Anchor href="https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html">
            https://rdl.train.army.mil/catalog-ws/view/modernwar/index.html
          </Anchor>
          )
        </Paragraph>
        <SectionBreak />
      </React.Fragment>
    );
  }
}

const Component = inject("AppState")(observer(Information));
Component.displayName = "Information";
export const InformationComponent = Information;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Information.js